export default __webpack_public_path__ + "static/Social-041441ea9d46dcca2c089d78bd770827.png";